module.exports = __webpack_public_path__ + "img/logo_gricad_horizontal.7d0b8834.png";